export const characters = {
  lyra: {
    name: "Lyra",
    color: "#7eb8f7",
    description: "Une elfe archère mystérieuse",
  },
  roi: {
    name: "Le Roi Aldric",
    color: "#f7c97e",
    description: "Le roi vieillissant du royaume de Valdris",
  },
  narrateur: {
    name: "Narrateur",
    color: "#aaaaaa",
    description: "",
  },
};

export const scenarios = [
  {
    id: 0,
    background: "forest",
    character: "narrateur",
    text: "Le royaume de Valdris est plongé dans l'obscurité. Une malédiction ancienne ronge ses terres depuis trois lunes. Tu es un aventurier de passage — et tu es peut-être le seul à pouvoir changer les choses.",
    choices: null,
    next: 1,
  },
  {
    id: 1,
    background: "forest",
    character: "lyra",
    text: null, // généré par l'IA
    aiPrompt: `Tu es Lyra, une elfe archère mystérieuse qui garde la forêt de Valdris maudite. 
Tu rencontres un aventurier inconnu. Adapte ta réaction selon ses stats :

- Si courage >= 7 : tu es impressionnée, tu baisses légèrement ton arc, ton ton est respectueux mais prudent
- Si courage entre 4 et 6 : tu es méfiante, arc tendu, ton ton est froid et distant
- Si courage <= 3 : tu es méprisante, tu le trouves trop ordinaire pour être ici

- Si sagesse >= 7 : tu remarques qu'il observe la forêt avec attention, ça t'intrigue
- Si sagesse <= 3 : tu le trouves imprudent et tu le lui fais savoir

Combine les deux stats pour une réaction nuancée. IMPÉRATIF : réponds en exactement 2 phrases. Stop après le point final de la 2ème phrase.`,
    choices: null,
    next: 2,
  },
  {
    id: 2,
    background: "forest",
    character: "lyra",
    text: "Le royaume a besoin d'aide. Mais le chemin vers le château est périlleux. Comment veux-tu procéder ?",
    choices: [
      {
        text: "Foncer directement au château.",
        stats: { courage: 2, sagesse: -1 },
        next: 3,
      },
      {
        text: "Explorer la forêt d'abord pour comprendre la malédiction.",
        stats: { courage: 0, sagesse: 2 },
        next: 4,
      },
    ],
  },
  {
    id: 3,
    background: "castle",
    character: "roi",
    text: null,
    aiPrompt: `Tu es le Roi Aldric, souverain vieillissant du royaume de Valdris rongé par une malédiction ancienne. 
Un aventurier arrive directement à ton château sans explorer la forêt — il a choisi la rapidité plutôt que la prudence.
Adapte ta réaction selon ses stats :

- Si courage >= 7 : tu es soulagé et reconnaissant, tu vois en lui un guerrier capable, ton ton est solennel et espérant
- Si courage entre 4 et 6 : tu es méfiant, tu te demandes s'il est vraiment à la hauteur, ton ton est hésitant
- Si courage <= 3 : tu es désespéré, tu n'as pas le choix de lui faire confiance, ton ton est résigné

- Si sagesse >= 7 : tu remarques sa perspicacité, tu lui confies plus de détails sur la malédiction
- Si sagesse <= 3 : tu gardes certains détails secrets, tu le juges trop impulsif pour tout savoir

Tu es épuisé, vieilli prématurément par la malédiction. Laisse transparaître ce poids. 2-3 phrases maximum.
IMPÉRATIF : réponds en exactement 2 phrases. Stop après le point final de la 2ème phrase.`,
    choices: null,
    next: 5,
  },
  {
    id: 4,
    background: "forest",
    character: "lyra",
    text: null,
    aiPrompt: `Tu es Lyra, une elfe archère qui explore la forêt maudite de Valdris avec un aventurier sage.
Vous venez de découvrir un indice sur l'origine de la malédiction — des symboles anciens gravés sur un arbre mort.
Adapte ta réaction selon ses stats :

- Si sagesse >= 7 : tu es fascinée, vous analysez ensemble les symboles, ton ton est complice et intellectuel
- Si sagesse entre 4 et 6 : tu expliques ce que tu vois, ton ton est pédagogue mais prudent  
- Si sagesse <= 3 : tu es frustrée qu'il ne comprenne pas, tu dois tout lui expliquer, ton ton est impatient

- Si courage >= 7 : tu proposes d'aller immédiatement à la source des symboles
- Si courage <= 3 : tu conseilles de rebrousser chemin et de revenir mieux préparés

IMPÉRATIF : réponds en exactement 2 phrases. Stop après le point final de la 2ème phrase.`,
    choices: null,
    next: 5,
  },
  {
    id: 5,
    background: "castle",
    character: "roi",
    text: "La malédiction vient des Ruines d'Andor. Seul un artefact ancien peut la briser. Acceptes-tu cette quête ?",
    choices: [
      { text: "J'accepte sans hésiter.", stats: { courage: 2 }, next: 7 },
      {
        text: "Je demande une récompense d'abord.",
        stats: { sagesse: 1 },
        next: 7,
      },
    ],
  },
  {
    id: 7,
    background: "forest",
    character: "narrateur",
    text: "Vous quittez le château à l'aube. La forêt de Valdris se referme derrière vous comme une mâchoire. Au loin, les Ruines d'Andor se devinent sous un ciel de cendre. Lyra marche en silence, arc à la main.",
    choices: null,
    next: 8,
  },
  {
    id: 8,
    background: "forest",
    character: "lyra",
    text: "Arrête-toi. Un garde corrompu barre le chemin — il a été touché par la malédiction. Ses yeux sont noirs. Il ne nous laissera pas passer sans violence. Comment tu veux gérer ça ?",
    choices: [
      {
        text: "L'affronter directement.",
        stats: { courage: 1, sagesse: -1 },
        next: 9,
      },
      {
        text: "Trouver un chemin détourné.",
        stats: { courage: -1, sagesse: 1 },
        next: 10,
      },
    ],
  },
  {
    id: 9,
    background: "forest",
    character: "lyra",
    text: null,
    aiPrompt: `Tu es Lyra, une elfe archère. L'aventurier vient de terrasser courageusement un garde corrompu par la malédiction. Tu es impressionnée par sa bravoure mais inquiète de l'énergie dépensée avant d'affronter les Ruines. IMPÉRATIF : réponds en exactement 2 phrases. Stop après le point final de la 2ème phrase.`,
    choices: null,
    next: 11,
  },
  {
    id: 10,
    background: "forest",
    character: "lyra",
    text: null,
    aiPrompt: `Tu es Lyra, une elfe archère. L'aventurier vient de trouver astucieusement un chemin détourné pour éviter un garde corrompu. Tu salues sa prudence mais notes que ce détour vous a fait perdre du temps précieux. IMPÉRATIF : réponds en exactement 2 phrases. Stop après le point final de la 2ème phrase.`,
    choices: null,
    next: 11,
  },
  {
    id: 11,
    background: "castle",
    character: "narrateur",
    text: "Les Ruines d'Andor se dressent devant vous. Des colonnes de pierre noire suintent d'une lumière violette. Au centre, sur un autel effondré, repose l'Artefact de Valdris — une gemme pulsant d'une énergie ancienne.",
    choices: null,
    next: 12,
  },
  {
    id: 12,
    background: "castle",
    character: "lyra",
    text: null,
    aiPrompt: `Tu es Lyra, une elfe archère. Vous êtes arrivés aux Ruines d'Andor et l'Artefact est devant vous. C'est le moment de vérité. Adapte ton ton selon les stats :
- Si courage >= 6 : tu es déterminée et prête au combat
- Si sagesse >= 6 : tu analyses l'artefact avec précision avant d'agir
- Si les deux sont moyens : tu es tendue, consciente du danger
L'artefact doit être touché pour briser la malédiction — mais il pourrait tuer celui qui le touche. Tu regardes l'aventurier. IMPÉRATIF : réponds en exactement 2 phrases. Stop après le point final de la 2ème phrase.`,
    choices: [
      {
        text: "Tu touches l'artefact sans hésiter.",
        stats: { courage: 2 },
        next: 13,
      },
      {
        text: "Tu cherches d'abord un moyen de te protéger.",
        stats: { sagesse: 2 },
        next: 14,
      },
    ],
  },
  {
    id: 13,
    background: "castle",
    character: "narrateur",
    text: "Tu poses la main sur la gemme. Une douleur fulgurante traverse ton corps — puis le silence. La lumière violette s'éteint. La malédiction de Valdris se brise dans un souffle. Tu es toujours vivant. À peine.",
    choices: null,
    next: 15,
  },
  {
    id: 14,
    background: "castle",
    character: "lyra",
    text: null,
    aiPrompt: `Tu es Lyra. L'aventurier cherche un moyen de se protéger avant de toucher l'artefact maudit. Ta sagesse combinée trouve une solution — une rune de protection gravée sur une colonne voisine. Tu la lui montres avec soulagement. IMPÉRATIF : réponds en exactement 2 phrases. Stop après le point final de la 2ème phrase.`,
    choices: null,
    next: 15,
  },
  {
    id: 15,
    background: "castle",
    character: "roi",
    text: null,
    aiPrompt: `Tu es le Roi Aldric. La malédiction vient d'être brisée — tu le sens dans tes os. Pour la première fois depuis des années, tu respires sans douleur. Tu regardes l'aventurier avec une gratitude profonde et solennelle. Adapte selon les stats : si courage élevé, tu salues son sacrifice ; si sagesse élevée, tu admires sa méthode. IMPÉRATIF : réponds en exactement 2 phrases. Stop après le point final de la 2ème phrase.`,
    choices: null,
    next: 16,
  },
  {
    id: 16,
    background: "castle",
    character: "narrateur",
    text: "Le royaume de Valdris respire à nouveau. La malédiction est brisée. Ton nom sera gravé dans les chroniques du royaume — celui qui osa entrer dans les bois maudits et en ressortit victorieux.",
    choices: null,
    next: null,
    end: true,
  },
];
